import React from 'react';
import styled from 'styled-components';

import { toCssSelector } from '@candu-ai/stylesheet/utils';
import Node from 'craft/components/Node';
import { BuiltInComponents } from 'craft/constants';
import { Resolver, ToolboxComponentSections } from 'craft/types';

export const BackdropNode = styled(Node)`
  overflow: hidden;
  height: 100%;
`;

export const Backdrop: Resolver = ({ children, ...otherProps }: any) => {
  const backdropClassName = toCssSelector('modal', {
    className: 'backdrop',
    output: 'html',
  });

  return (
    <BackdropNode
      is="div"
      id="backdrop"
      className={backdropClassName}
      style={{
        position: 'relative', // because of SG
        zIndex: 'unset', // because of SG
        display: 'flex',
        flex: 1,
      }}
      data-cy="node-modal-backdrop"
      {...otherProps}
    >
      {children}
    </BackdropNode>
  );
};

Backdrop.toolbox = {
  schema: {
    [ToolboxComponentSections.Size]: {
      isVisible: false,
    },
  },
};

Backdrop.craft = {
  name: BuiltInComponents.Backdrop,
  isCanvas: true,
  rules: {
    canDelete: () => false,
    canDrag: () => false,
    canDrop: () => false,
    canMoveIn: () => false,
    canMoveOut: () => false,
  },
};
